module.exports={"login-screen":{title:"Bonjour ! Veuillez vous connecter",form:{username:"Adresse email ou Nom d'utilisateur",password:"Mot de passe"}}};